import { render } from "./SidebarButton.vue?vue&type=template&id=57bffba1"
import script from "./SidebarButton.vue?vue&type=script&lang=js"
export * from "./SidebarButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__